import React from 'react';
import {Description, FooterWrapper} from "../Styles";
import {Link} from "react-router-dom";
import {routes} from "../../Constants/Constants";

const Footer = () => {
    return (
        <FooterWrapper>
            <Description style={{color: 'white'}}>
                © 2020 Shtëpia+
            </Description>
            <Description style={{color: 'white'}}>
                <Link to={`${routes.App.Privacy}`} style={{color: 'white', textDecoration: 'blink'}}> Privacy
                    Policy </Link>
            </Description>
        </FooterWrapper>
    );
}

export default Footer;